import * as tslib_1 from "tslib";
import { Field } from './field';
var FieldWrapper = (function (_super) {
    tslib_1.__extends(FieldWrapper, _super);
    function FieldWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FieldWrapper;
}(Field));
export { FieldWrapper };
//# sourceMappingURL=field.wrapper.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/src/templates/field.wrapper.js
// module id = 766
// module chunks = 3